import { render, staticRenderFns } from "./ListServiceOrdes.vue?vue&type=template&id=66354740&scoped=true"
import script from "./ListServiceOrdes.vue?vue&type=script&lang=js"
export * from "./ListServiceOrdes.vue?vue&type=script&lang=js"
import style0 from "./ListServiceOrdes.vue?vue&type=style&index=0&id=66354740&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66354740",
  null
  
)

export default component.exports